import Route from '@ember/routing/route';

export default class StudentNoticesRoute extends Route {}
